var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addEditForm" }, [
    _c("div", { staticClass: "formTitle" }, [_vm._v("基本信息修改")]),
    _vm._v(" "),
    _c("div", { staticClass: "ownBox" }, [
      _c(
        "div",
        { staticClass: "footerBtn" },
        [
          _c("FileImg", {
            attrs: { propImg: _vm.avatar },
            on: { successUpLoad: _vm.successUpLoad },
          }),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "changTips" }, [
                _vm._v("点击上方,修改头像"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "userInfoUpData" },
        [
          _c(
            "el-form",
            {
              ref: "changeForm",
              attrs: {
                "label-width": "220px",
                rules: _vm.rules,
                model: _vm.userInfo,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "昵称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "name" },
                        model: {
                          value: _vm.userInfo.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "name", $$v)
                          },
                          expression: "userInfo.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "submitBtn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: {
              click: function ($event) {
                return _vm.submitForm("changeForm")
              },
            },
          },
          [_vm._v("提交")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small", plain: "" },
            on: { click: _vm.isBack },
          },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }